<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<footer
  class='d-flex align-items-center text-center text-lg-start col-12 footer'
>
  <div class='container p-4 pb-0'>
    <section class='m-lg-3'>
      <div class='row'>

        <div class='col-md-4 col-lg-3 col-xl-3 mx-auto mt-5 mb-5'>
          <h3 class='text-uppercase mb-4 font-weight-bold'>
            {{ 'footer.companyDetails' | translate }}
          </h3>
          <p class='mb-2'>
            <i class='fa-solid fa-home mr-2'></i>{{ platformCompanyRegistrationDTO?.companyName }}
          </p>
          <p class='mb-2'>
            <i class='fas fa-print mr-2'></i>{{ platformCompanyRegistrationDTO?.uniqueIdentificationNumber }}
          </p>
          <p class='mb-2'>
            <i class='fas fa-print mr-2'></i>{{ platformCompanyRegistrationDTO?.registrationCode }}
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-envelope mr-2'></i>{{ platformCompanyRegistrationDTO?.mainEmailAddress }}
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-phone mr-2'></i>{{ platformCompanyRegistrationDTO?.mainPhoneNumber }}
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-inbox mr-2'></i>
            <a
              [routerLink]='platformCompanyContactFormUrl()'
              [queryParams]='{ backNavigationHistoryPreserve: false }' data-testid="platform-company-contact-form-url-link">{{ translationSchema['footer'].contactUs | translate }}
            </a>
          </p>
        </div>

        <hr class='w-100 clearfix d-md-none' />

        <div class='col-md-4 col-lg-3 col-xl-3 mx-auto mt-5 mb-5'>
          <h3 class='text-uppercase mb-4 font-weight-bold'>{{ 'footer.usefulLinks.links' | translate }}</h3>
          <p class='mb-2'>
            <i class='fa-solid fa-circle-dot mr-2'></i>
            <a
              [routerLink]="loggedInUser ? loggedInTermsAndConditionsPageUrl : guestTermsAndConditionsPageUrl"
              class='nav-link'
              target='_blank' data-testid="terms-and-conditions-link">{{ 'footer.usefulLinks.termsAndConditions' | translate }}</a>
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-circle-dot mr-2'></i>
            <a
              [routerLink]="loggedInUser ? loggedInTermsAndConditionsPageUrl : guestTermsAndConditionsPageUrl"
              class='nav-link p-0'
              target='_blank' data-testid="privacy-policy-link">{{ 'footer.usefulLinks.privacyPolicy' | translate }}</a>
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-circle-dot mr-2'></i>
            <a
              [routerLink]="loggedInUser ? loggedInTermsAndConditionsPageUrl : guestTermsAndConditionsPageUrl"
              class='nav-link p-0'
              target='_blank' data-testid="cookie-policy-link">{{ 'footer.usefulLinks.cookiePolicy' | translate }}</a>
          </p>
          <p class='mb-2'>
            <i class='fa-solid fa-circle-dot mr-2'></i>
            <a href='https://anpc.ro/' class='nav-link p-0'
               target='_blank' data-testid="anpc-link">{{ 'footer.usefulLinks.ANPC' | translate }}</a>
          </p>
        </div>

        <hr class='w-100 clearfix d-md-none' />

        <div class='col-md-4 col-lg-3 col-xl-3 mx-auto mb-5 mt-5 text-center'>
          <div class='d-flex flex-column align-items-center mb-4'>
            <well-ntp-logo></well-ntp-logo>
          </div>

          <div class='d-flex justify-content-center mb-3'>
            <a href='https://anpc.ro/ce-este-sal/' target='_blank' rel='nofollow' class='d-inline-block' data-testid="link">
              <img style='width:61%;' src='https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sal.png'
                   alt='Solutionarea Alternativa a Litigiilor'>
            </a>
          </div>

          <div class='d-flex justify-content-center'>
            <a href='https://ec.europa.eu/consumers/odr' target='_blank' rel='nofollow' class='d-inline-block' data-testid="link-2">
              <img style='width:60%;' src='https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sol.png'
                   alt='Solutionarea Online a Litigiilor'>
            </a>
          </div>
        </div>


      </div>
    </section>

    <hr class='my-3 mb-4'>

    <div class='m-lg-3 d-flex justify-content-center'>
      <a [routerLink]='"/"' data-testid="link-3">
        <img class='truck-logo' src='assets/footer_logo.png' height='70px' alt='truck-logo'>
      </a>
    </div>

  </div>
</footer>


